import axios from "axios";
import {limpiarNumero} from "../../Modulo_ChatWass/Funciones/limpiarNumero";
import {obtenerIndicativoPais} from "../../Modulo_ChatWass/Funciones/obtenerIndicativoPais";
import dayjs from "dayjs";

export const enviarNotificacionReserva = async (entidad) => {


    let obj = {
        celular: obtenerIndicativoPais(entidad.pais) + limpiarNumero(entidad.celular),
        mensaje: `Casa de los cristales dice: \n
${entidad.nombre}, su reserva a sido creada con exito para el dia: \n${dayjs(entidad.fechaInicio).format('dddd DD MMMM YYYY HH:mm a').toUpperCase()}`
    }

    let data = JSON.stringify(obj);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/e41d5bcf-f95d-41da-91cc-aabfa4e52202', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/e41d5bcf-f95d-41da-91cc-aabfa4e52202',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}